"use client";

// next's built-in solutions dont let us access cookies on the client, the normal google suggestion was to use js-cookie
// but this works fine i think
export function getAccessTokenFromCookie(): string | null {
  if (typeof document === "undefined") return null;

  const value = document.cookie
    .split("; ")
    .find((row) => row.startsWith("access_token="))
    ?.split("=")[1];

  return value || null;
}

export function getRefreshTokenFromCookie(): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  const value = document.cookie
    .split("; ")
    .find((row) => row.startsWith("refresh_token="))
    ?.split("=")[1];

  return value || null;
}
